import Checkbox from "@streeteasy/design-system/deprecated/Checkbox";
import { number } from "prop-types";

import * as S from "./styled";

// TODO: react-ui-components candidate
const Switch = S.Input;

Switch.propTypes = {
  componentSize: number,
  ...Checkbox.propTypes
};

Switch.defaultProps = {
  componentSize: 1,
  ...Checkbox.defaultProps
};

export default Switch;
